import { isValidEmail } from '@domain-group/javascript-utils'

import { useForm } from '@domain-group/react-hooks'

import usePublication from '@hooks/usePublication'
import usePublicationEdition from '@hooks/usePublicationEdition'
import usePublicationOrder from '@hooks/usePublicationOrder'

import { PublicationEditionModel, PublicationModel } from '@models/types'

const customRequiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
]

// filter out the ccEmail if it is an empty string
const getEmails = (email: string, ccEmail: string) => {
  const emails = [email]
  if (ccEmail) emails.push(ccEmail)

  return emails
}

type UseCreatePublicationOrderModalParams = {
  publication: Partial<PublicationModel>,
  publicationEdition: Partial<PublicationEditionModel>,
}

const useCreatePublicationOrderModal = (params: UseCreatePublicationOrderModalParams) => {
  const { publication: initPublication, publicationEdition: initPublicationEdition } = params

  const { publication } = usePublication(initPublication)

  const publicationEditionPayload = usePublicationEdition(initPublicationEdition)
  const {
    bookingDeadlinePassed,
    publicationEdition,
  } = publicationEditionPayload

  const publicationOrderPayload = usePublicationOrder()
  const {
    callbacks: {
      createPublicationOrder,
    },
    creating,
    updating,
  } = publicationOrderPayload

  const defaultEmail = publication.booking_email || publication.email || ''

  const formPayload = useForm(
    { ccEmail: '', email: defaultEmail },
    { requiredFields: customRequiredFields, validateOn: 'change' },
  )

  const {
    entityState,
    errors,
    handlers,
    saveEnabled,
  } = formPayload

  return {
    bookingDeadlinePassed,
    callbacks: {
      createPublicationOrder,
      getEmails: (email: string, ccEmail: string) => getEmails(email, ccEmail),
    },
    creating,
    entityState,
    errors,
    handlers,
    publication,
    publicationEdition,
    saveEnabled,
    updating,
  }
}

export default useCreatePublicationOrderModal
